import { render } from "./SportTicketDetails.vue?vue&type=template&id=1a111014"
import script from "./SportTicketDetails.vue?vue&type=script&lang=js"
export * from "./SportTicketDetails.vue?vue&type=script&lang=js"

import "./SportTicketDetails.vue?vue&type=style&index=0&id=1a111014&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/UltimaMonitor_lgames/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__